var map = {
	"./Free Physiotherapy camp for warkari 3.jpeg": 4966,
	"./Free Physiotherapy camp for warkari 4.jpeg": 77455,
	"./Free Physiotherapy camp for warkari 5.jpeg": 72856,
	"./Free Physiotherapy camp for warkari 6.jpeg": 51001,
	"./Free Physiotherapy camp for warkari 7.jpeg": 20146,
	"./Free Physiotherapy camp for warkari.jpeg": 18667,
	"./Free Physiotherapy camp for warkari1.jpeg": 25766,
	"./Free Physiotherapy camp for warkari2.jpeg": 23827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86494;